// Formatea una fecha de DÍA PURO sin que se corra un día.
//
// ⚠ SOLO para columnas DATE (días de calendario): sheet_date, receipts.date,
// pto_requests.start_date/end_date, timesheets.week_start, company_holidays.date.
//
// ⚠ NO USAR para timestamps (TIMESTAMPTZ: created_at, uploaded_at, exported_at,
// responded_at, edited_at, reached_reviewer_at…). Un timestamp es un INSTANTE y
// convertirlo a la zona del que mira es lo CORRECTO — pasarlo por acá le recortaría
// la hora y mostraría el día UTC, que al oeste de UTC puede ser el día equivocado.
// Para esos usá `new Date(v).toLocaleString(...)` directo (ver AuditLogViewer.jsx).
//
// El bug que arregla: el driver de pg devuelve una columna DATE como objeto Date, que
// al serializarse a JSON viaja como instante ISO ('2026-07-29T00:00:00.000Z' cuando el
// servidor corre en UTC). `new Date(ese_iso).toLocaleDateString()` lo convierte a la
// zona del navegador: en AST (UTC−4) da 2026-07-28 20:00 → rotulaba "28 jul". El
// desfase solo aparece cuando la TZ del servidor difiere de la del que mira, por eso
// es invisible en desarrollo y visible en producción.
//
// La técnica (descomposición): recortar a 'YYYY-MM-DD' y construir la fecha con los
// componentes en hora LOCAL, así no hay ninguna conversión de zona que pueda correrla.
// Se eligió sobre el patrón `+ 'T12:00:00Z'` porque éste es inmune a los DOS formatos
// de cable — el mismo campo llega como ISO en unos endpoints y como string puro en
// otros (`to_char`), y concatenar 'T12:00:00Z' sobre un ISO da Invalid Date.
//
// Mismo patrón ya usado en TarjetaPage.jsx, TarjetaDetailPage.jsx, ProjectSheetsPage.jsx
// y NominaHomePage.jsx; este helper lo centraliza para que no vuelva a divergir.
export function formatDateSafe(
  value,
  opts = { year: 'numeric', month: 'short', day: 'numeric' },
  locale = 'es-PR',
) {
  if (!value) return '—';
  const [y, m, d] = String(value).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return '—';           // valor inesperado → guion, nunca "Invalid Date"
  return new Date(y, m - 1, d).toLocaleDateString(locale, opts);
}
